export default __webpack_public_path__ + "static/caixa3-605a0abc4651598acbd5a20ba5db5a36.webp";